/**
 * Per-player chat rate limit: a token bucket.
 *
 * A burst of a few messages is normal conversation; a sustained stream is spam.
 * The bucket allows the burst and then admits one message per refill interval,
 * which is exactly that distinction. Pure and clock-injected so the server and
 * the tests share one definition of "too fast".
 */
export const DEFAULT_CHAT_BURST = 3;
export const DEFAULT_CHAT_PER_SECOND = 0.5;
export class ChatRateLimiter {
    burst;
    refillPerMs;
    tokens;
    lastAt;
    constructor(now, options = {}) {
        this.burst = options.burst ?? DEFAULT_CHAT_BURST;
        this.refillPerMs = (options.perSecond ?? DEFAULT_CHAT_PER_SECOND) / 1000;
        this.tokens = this.burst;
        this.lastAt = now;
    }
    refill(now) {
        const elapsed = Math.max(0, now - this.lastAt);
        this.tokens = Math.min(this.burst, this.tokens + elapsed * this.refillPerMs);
        this.lastAt = now;
    }
    /** Spend a token if one is available; otherwise say how long to wait. */
    tryConsume(now) {
        this.refill(now);
        if (this.tokens >= 1) {
            this.tokens -= 1;
            return { allowed: true, retryInMs: 0 };
        }
        return { allowed: false, retryInMs: Math.ceil((1 - this.tokens) / this.refillPerMs) };
    }
}
//# sourceMappingURL=chat-limit.js.map